import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home/Home'
import about from '@/components/companyProfile/company'
import cooperation from "@/components/cooperation/cooperation"
import software from "@/components/software/software"


import chineseHome from '@/components/home/chineseHome'
import chineseAbout from '@/components/companyProfile/chineseCompany'
import chineseCooperation from "@/components/cooperation/chineseCooperation"
import chineseSoftware from "@/components/software/chineseSoftware"


import englishHome from '@/components/home/englishHome'
import englishAbout from '@/components/companyProfile/englishCompany'
import englishCooperation from "@/components/cooperation/englishCooperation"
import englishSoftware from "@/components/software/englishSoftware"



Vue.use(Router)


const  routes = [
    {
      path: '/',
      name: 'chineseHome',
      redirect: '/chineseHome'
    },

    {
      path: '/chineseHome',
      name: 'chineseHome',
      component: chineseHome
    },

    {
      path: '/englishHome',
      name: 'englishHome',
      component: englishHome
    },
    {
      path: '/chineseAbout',
      name: 'chineseAbout',
      component: chineseAbout
    },

    {
      path: '/englishAbout',
      name: 'englishAbout',
      component: englishAbout
    },

    {
      path: '/about',
      name: 'about',
      component: about
    },


    {
      path: '/cooperation',
      name: 'cooperation',
      component: cooperation
    },

    {
      path: '/chineseCooperation',
      name: 'chineseCooperation',
      component: chineseCooperation
    },

    {
      path: '/englishCooperation',
      name: 'englishCooperation',
      component: englishCooperation
    },
    {
      path: '/software',
      name: 'software',
      component: software
    },
    {
      path: '/chineseSoftware',
      name: 'chineseSoftware',
      component: chineseSoftware
    },
    {
      path: '/englishSoftware',
      name: 'englishSoftware',
      component: englishSoftware
    }

  ]

const vuerote=new Router(
  {
    routes,
    mode:'hash'
  }
)

export default vuerote



// WEBPACK FOOTER //
// ./src/router/index.js